import Locations  from './Locations';

export default Locations;
